<template>
  <div v-if="$buttonAuthority(allButton, 'list')">
    <div v-if="!isReply">
      <div class="search-class">
        <el-form
          :model="searchTxt"
          :inline="true"
          size="small"
          class="serarch-form"
        >
          <el-form-item label="平台账号">
            <el-select
              v-model="searchTxt.accountId"
              clearable
              filterable
              placeholder="请选择"
              class="input-width-two"
            >
              <el-option
                v-for="(val, key, i) in dropList.platformList"
                :label="val"
                :value="key"
                :key="i"
              ></el-option>
            </el-select>
          </el-form-item>
          <el-form-item label="邮件主题">
            <el-input v-model="searchTxt.subject"></el-input>
          </el-form-item>
          <el-form-item label="收件人">
            <el-input v-model="searchTxt.sender"></el-input>
          </el-form-item>
          <el-form-item label="添加时间">
            <el-date-picker
              v-model="searchTxt.createdTimeBegin"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
            -
            <el-date-picker
              v-model="searchTxt.createdTimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择日期时间"
            >
            </el-date-picker>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="search()" icon="el-icon-search"
              >查找</el-button
            >
            <el-button @click="reset()" icon="el-icon-refresh">重置</el-button>
          </el-form-item>
        </el-form>
      </div>
      <div class="main-table">
        <div class="table-header">
          <el-button
            @click="batchSend"
            class="button-class"
            icon="el-icon-message"
            v-if="$buttonAuthority(allButton, 'batchSend')"
            >批量发送</el-button
          >
        </div>
        <commonTable
          ref="multipleTable"
          type="selection"
          :loading="loading"
          :tableData="tableData"
          :tableLabel="tableLabel"
          @handleSizeChange="handleSizeChange"
          @handleCurrentChange="handleCurrentChange"
          :pageSize="pagination.pageSize"
          :currentPage="pagination.page"
          :total="pagination.total"
          :tableOption="tableOption"
          @handleButton="handleButton"
          @handleSelectionChange="handleSelectionChange"
        ></commonTable>
      </div>
    </div>
    <div v-if="isReply">
      <replay
        :scope="scope"
        @isShowEdit="isShowEdit"
        @getList="getList"
      ></replay>
    </div>
    <div v-if="isLog">
      <logLook
        :modelName="modelName"
        :logType="logType"
        :id="scope.id"
        @lookClick="isShowEdit"
      ></logLook>
    </div>
  </div>
</template>
<script>
/**
 * eBay 邮件草稿箱列表页
 * 功能：按平台账号/主题/收件人/添加时间搜索，批量发送草稿，单条编辑（进入 replay 详情）与查看日志
 */
import { ebayMessageDraft, sendBatch } from '@/api/user'
import replay from '../eabyInbox/components/replay'
export default {
  components: {
    replay,
  },
  data() {
    return {
      modelName: 'mail',
      logType: 'draft',
      // 列表加载状态
      loading: true,
      isshowhidden: false,
      // 是否首次加载（首次加载后生成列定义）
      isFirst: true,
      // 是否进入草稿编辑详情页
      isReply: false,
      // 是否打开日志弹窗
      isLog: false,
      // 当前选中行数据
      scope: {},
      hiddenHeader: [],
      // 按钮权限列表
      allButton: [],
      // 草稿列表数据
      tableData: [],
      // 表格列定义
      tableLabel: [],
      // 后端返回的列标题映射
      titleMap: [],
      dropList: {},
      renderList: {},
      // 批量勾选的草稿数据
      dataList: [],
      // 搜索条件
      searchTxt: {
        accountId: '',
        subject: '',
        sender: '',
        createdTimeBegin: '',
        createdTimeEnd: '',
      },
      // 分页参数
      pagination: {
        page: 1,
        pageSize: 10,
        total: 0,
      },
      // 表格操作列定义（编辑、日志）
      tableOption: {
        label: '操作',
        minWidth: '150',
        fixed: 'right',
        options: [
          {
            label: '编辑',
            type: 'text',
            methods: 'edit',
            size: 'mini',
          },
          {
            label: '日志',
            type: 'text',
            methods: 'log',
            size: 'mini',
          },
        ],
      },
    }
  },
  activated() {
    // 页面激活时获取按钮权限、加载列表并过滤操作列权限
    this.allButton = this.$getStorage(this.$route.name + '_button')
    if (this.$buttonAuthority(this.allButton, 'list')) {
      this.getList()
      this.tableOptionAuth()
    }
  },
  methods: {
    /** 基于后端列映射生成表格列定义（主题列可点击进入编辑详情） */
    getTableLabel() {
      this.tableLabel = this.$getTableLabel(this.titleMap, this.renderList)
      let param = {
        label: '邮件主题',
        param: 'subject',
        align: 'center',
        show: true,
        render: (h, param) => {
          return h(
            'span',
            {
              style: {
                color: 'rgb(64, 158, 255)',
                cursor: 'pointer',
              },
              on: {
                click: () => {
                  param.row.draftId = param.row.id
                  this.scope = [param.row]
                  this.isReply = true
                },
              },
            },
            param.row.subject
          )
        },
      }
      this.tableLabel.splice(4, 1)
      this.tableLabel.splice(4, 0, param)
      this.loading = false
    },
    /** 表格操作列按钮分发（日志/编辑） */
    handleButton(data) {
      var funType = data.methods
      if (funType === 'log') {
        this.logInfo(data.row)
      } else if (funType == 'edit') {
        this.editInfo(data.row)
      }
    },
    /** 同步 eBay 账号（疑似废弃：调用未导入的 ebayAccountSync，且无按钮绑定） */
    accountSync() {
      ebayAccountSync()
        .then((result) => {
          if (result.code == 200) {
            this.$message.success('同步成功')
            this.getList()
          }
        })
        .catch((err) => {})
    },
    /** 关闭所有弹窗/详情页，回到列表 */
    isShowEdit() {
      this.isLog = false
      this.isReply = false
    },
    /** 打开日志弹窗 */
    logInfo(data) {
      this.scope = data
      this.isLog = true
    },
    /** 进入草稿编辑详情页 */
    editInfo(data) {
      data.draftId = data.id
      this.scope = [data]
      this.isReply = true
    },
    /** 查询草稿列表 */
    getList() {
      this.loading = true
      ebayMessageDraft(this.pagination).then((result) => {
        if (result.code == 200) {
          this.tableData = result.data.pageInfo.records
          this.pagination.total = result.data.pageInfo.total
          let label = result.data.renderList
          this.dropList = result.data.dropList
          if (label == null) {
            this.renderList = {}
          } else {
            Object.assign(this.renderList, label)
          }
          if (this.isFirst) {
            this.titleMap = result.data.titleMap
            this.getTableLabel()
          } else {
            this.loading = false
          }
        }
      })
    },
    /** 批量发送选中的草稿 */
    batchSend() {
      if (this.dataList.length > 0) {
        this.$confirm('确认发送选中内容？', '确认', {
          distinguishCancelAndClose: true,
          confirmButtonText: '确认',
          cancelButtonText: '取消',
        })
          .then(() => {
            let ids = this.dataList.map((item) => {
              return item.id
            })
            let param = {
              ids: ids,
            }
            sendBatch(param)
              .then((result) => {
                if (result.code == 200) {
                  this.$message.success('发送成功')
                  this.getList()
                  this.$refs.multipleTable.clear()
                }
              })
              .catch((err) => {
                this.$refs.multipleTable.clear()
              })
          })
          .catch((action) => {})
      } else {
        this.$message.warning('请选择发送内容')
      }
    },
    /** 分页大小变化时重新查询 */
    handleSizeChange(value) {
      this.pagination.pageSize = value
      this.pagination.page = 1
      this.getList()
    },
    /** 页码变化时重新查询 */
    handleCurrentChange(value) {
      this.pagination.page = value
      this.getList()
    },
    /** 勾选变化时记录选中的草稿数据 */
    handleSelectionChange(value) {
      this.dataList = value
    },
    /** 按搜索条件查询草稿列表 */
    search() {
      this.pagination.page = 1
      Object.assign(this.pagination, this.searchTxt)
      this.isFirst = false
      this.getList()
    },
    /** 清空搜索条件并重新查询 */
    reset() {
      this.pagination.page = 1
      this.$delectObj(this.searchTxt, [
        'accountId',
        'subject',
        'sender',
        'createdTimeBegin',
        'createdTimeEnd',
      ])
      this.$delectObj(this.pagination, [
        'accountId',
        'subject',
        'sender',
        'createdTimeBegin',
        'createdTimeEnd',
      ])
      this.isFirst = false
      this.getList()
    },
    /** 按按钮权限过滤表格操作列 */
    tableOptionAuth() {
      let array = this.tableOption.options
      let authOption = []
      array.forEach((element) => {
        if (this.$buttonAuthority(this.allButton, element.methods)) {
          authOption.push(element)
        }
      })
      if (authOption.length > 0) {
        this.tableOption.options = authOption
      } else {
        this.tableOption = {}
      }
    },
  },
  mounted() {},
}
</script>

<style scoped></style>
